import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import {
  Dialog,
  DialogContent,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { X, Download } from "lucide-react";

export const PhotoWarningDialog = ({ open, onOpenChange }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="rounded-sm">
      <AlertDialogHeader>
        <AlertDialogTitle>Serial Number Photo Required</AlertDialogTitle>
        <AlertDialogDescription>
          Please take a photo of the excavator&apos;s serial number plate before checking in.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogAction className="bg-blue-600 hover:bg-blue-700 rounded-sm">
          OK
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const SerialNumberWarningDialog = ({ open, onOpenChange }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="rounded-sm">
      <AlertDialogHeader>
        <AlertDialogTitle>Serial Number Required</AlertDialogTitle>
        <AlertDialogDescription>
          Please scroll down to the &quot;Serial Number&quot; section and enter the serial number.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogAction className="bg-blue-600 hover:bg-blue-700 rounded-sm">
          OK
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const WorkPhotoWarningDialog = ({ open, onOpenChange, missingTypes }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="rounded-sm">
      <AlertDialogHeader>
        <AlertDialogTitle>Work Photos Required</AlertDialogTitle>
        <AlertDialogDescription>
          Please upload at least 1 work photo for each job type before checking out.
          {missingTypes && missingTypes.length > 0 && (
            <span className="block mt-2 font-medium">
              Missing photos for: {missingTypes.join(", ")}
            </span>
          )}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogAction className="bg-blue-600 hover:bg-blue-700 rounded-sm">
          OK
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const SignatureWarningDialog = ({ open, onOpenChange }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="rounded-sm">
      <AlertDialogHeader>
        <AlertDialogTitle>Customer Signature Required</AlertDialogTitle>
        <AlertDialogDescription>
          Please scroll down to the &quot;Customer Signature&quot; section and capture the customer&apos;s signature.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogAction className="bg-blue-600 hover:bg-blue-700 rounded-sm">
          OK
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const PhotoLightbox = ({ photo, onClose }) => {
  if (!photo) return null;

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = photo;
    link.download = `photo-${Date.now()}.jpg`;
    link.click();
  };

  return (
    <Dialog open={!!photo} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-4xl p-0 rounded-sm overflow-hidden">
        <div className="relative">
          <img src={photo} alt="Enlarged" className="w-full h-auto max-h-[80vh] object-contain" />
          <div className="absolute top-2 right-2 flex gap-2">
            <Button
              size="icon"
              variant="secondary"
              onClick={handleDownload}
              className="rounded-sm bg-white/80 hover:bg-white"
            >
              <Download className="w-4 h-4" />
            </Button>
            <Button
              size="icon"
              variant="secondary"
              onClick={onClose}
              className="rounded-sm bg-white/80 hover:bg-white"
            >
              <X className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default {
  PhotoWarningDialog,
  SerialNumberWarningDialog,
  WorkPhotoWarningDialog,
  SignatureWarningDialog,
  PhotoLightbox,
};
